<template>
  <div v-if="chipGroups.length" class="flex min-w-0 items-center gap-1.5">
    <div
      v-for="group in chipGroups"
      :key="group.key"
      :title="group.title"
      class="flex h-8 min-w-0 shrink items-center gap-2 rounded-chip border
        pl-3 pr-2 text-label font-medium whitespace-nowrap
        transition-[background-color,border-color,color] duration-150"
      :class="TONE[group.kind] || TONE.plain"
    >
      <span
        v-if="group.items"
        class="shrink-0 font-medium text-text-muted"
      >{{ group.label }}</span>

      <div v-if="group.kind === 'users'" class="flex shrink-0 items-center">
        <UserAvatar
          noPendingBadge
          v-for="item in group.items"
          :key="item.key"
          :user="item.user"
          :title="`${group.label}: ${item.name}`"
          class="size-4.5! -ml-1! first:ml-0! shrink-0 cursor-pointer
            transition-opacity duration-150 hover:opacity-55 [&_.content]:text-[0.625rem]!"
          @click="clearItem(group, item)"
        />
      </div>

      <div v-else-if="group.kind === 'tags'" class="flex min-w-0 items-center gap-2">
        <span
          v-for="item in group.items"
          :key="item.key"
          :title="`${group.label}: ${item.name}`"
          class="flex min-w-0 cursor-pointer items-center gap-1.5
            transition-opacity duration-150 hover:opacity-55"
          @click="clearItem(group, item)"
        >
          <span
            v-if="item.color"
            class="size-2 shrink-0 rounded-full"
            :style="{ background: item.color }"
          ></span>
          <span class="truncate">{{ item.name }}</span>
        </span>
      </div>

      <span v-else class="truncate">{{ group.label }}</span>

      <button
        v-if="group.more"
        type="button"
        class="shrink-0 cursor-pointer border-0 bg-transparent p-0 text-text-muted
          transition-colors duration-150 hover:text-accent"
        @click="openFilters"
      >+{{ group.more }}</button>

      <button
        type="button"
        :title="`${t('search.clear')}: ${group.label}`"
        class="flex size-4 shrink-0 cursor-pointer items-center justify-center rounded-full
          border-0 bg-transparent p-0 text-current opacity-45
          transition-opacity duration-150 hover:opacity-100"
        @click.stop="clearGroup(group)"
      >
        <IconXMark16Solid class="size-3.5" />
      </button>
    </div>

    <button
      type="button"
      class="shrink-0 cursor-pointer border-0 bg-transparent pl-1 pr-0 text-label font-medium
        text-text-muted transition-colors duration-150 hover:text-accent"
      @click="clearAll"
    >{{ t('search.clear') }}</button>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { IconXMark16Solid } from '@iconify-prerendered/vue-heroicons';
import UserAvatar from '@/components/elements/UserAvatar';
import { useTaskFilterChips } from '@/composables/useTaskFilterChips';

const TONE = {
  plain: 'border-line bg-input text-text hover:border-accent',
  search: `border-[color-mix(in_srgb,var(--accent)_40%,transparent)] bg-accent-soft text-accent`,
};

const { t } = useI18n();
const {
  chipGroups, clearGroup, clearItem, clearAll, openFilters,
} = useTaskFilterChips();
</script>
